export const binary_options = [
  {
    label: "Yes",
    value: true
  },
  {
    label: "No",
    value: false
  }
]

export const dental_cover_options = [
  {
    label: "₹3K",
    value: "3k"
  },
  {
    label: "₹5K",
    value: "5k"
  },
  {
    label: "No",
    value: false
  }
]

export const gtli_options = [
  {
    label: "₹5L",
    value: "5L"
  },
  {
    label: "₹10L",
    value: "10L"
  },
  {
    label: "₹20L",
    value: "20L"
  },
  {
    label: "₹30L",
    value: "30L"
  },
  {
    label: "No",
    value: false
  }
]

export const gpa_options = [
  {
    label: "₹5L",
    value: "5L"
  },
  {
    label: "₹10L",
    value: "10L"
  },
  {
    label: "₹20L",
    value: "20L"
  },
  {
    label: "₹50L",
    value: "50L"
  },
  {
    label: "No",
    value: false
  }
]

export const plan_type_options = [
  {
    label: "Silver (Normal - 1% of SI; ICU - 2% of SI)",
    value: "silver"
  },
  {
    label: "Gold (Normal - 2% of SI; ICU - 4% of SI)",
    value: "gold"
  },
  {
    label: "Platinum (Normal & ICU - No limit)",
    value: "platinum"
  }
]

export const city_options = [
  {
    label: "Ahmedabad",
    value: "ahmedabad"
  },
  {
    label: "Bangalore",
    value: "bangalore"
  },
  {
    label: "Chennai",
    value: "chennai"
  },
  {
    label: "Delhi",
    value: "delhi"
  },
  {
    label: "Hyderabad",
    value: "hyderabad"
  },
  {
    label: "Kolkata",
    value: "kolkata"
  },
  {
    label: "Mumbai",
    value: "mumbai"
  },
  {
    label: "Pune",
    value: "pune"
  },
  {
    label: "Secunderabad",
    value: "secunderabad"
  },
  {
    label: "Surat",
    value: "surat"
  },
  {
    label: "Vadodara",
    value: "vadodara"
  },
  {
    label: "Rest of India",
    value: "rest_of_india"
  }
]

export const doctor_teleconsultations_options = [
  {
    label: "GP Only (Unlimited for Family)",
    value: "gp"
  },
  {
    label: "GP + 10 Specialities (Unlimited for Family)",
    value: "gp10"
  },
  {
    label: "GP + 16 Specialities (Unlimited for Family)",
    value: "gp16"
  },
  {
    label: "No",
    value: false
  },
]

export const digit_age_range_options = [
  {
    label: '0-25 years',
    value: 25
  },
  {
    label: '25-35 years',
    value: 35
  },
  {
    label: '35-45 years',
    value: 45
  },
  {
    label: '45-55 years',
    value: 55
  },
  {
    label: '55-65 years',
    value: 65
  },
]

export const health_checkups_options = [
  {
    label: "Lite (38 Parameters)",
    value: "lite"
  },
  {
    label: "Basic (79 Parameters)",
    value: "basic"
  },
  {
    label: "Advanced (83 Parameters)",
    value: "advanced"
  },
  {
    label: "Comprehensive (87 Parameters)",
    value: "comprehensive"
  },
  {
    label: "No",
    value: false
  },
]

export const opd_cover_options = [
  {
    label: "Silver (₹3k) - Doctor Consultations, Diagnostics",
    value: '3000'
  },
  {
    label: "Gold (₹15k) - Doctor Consultations, Diagnostics, Medicines",
    value: '15000'
  },
  {
    label: "Platinum (₹30k) - Doctor Consultations, Diagnostics, Medicines, Vision, Dental, Vaccines",
    value: '30000'
  },
  {
    label: "No",
    value: false
  },
]

export const family_type_legend = [
  {
    id: 1,
    short_name: 'E',
    long_name: 'Employee Only'
  },
  {
    id: 2,
    short_name: 'ESC',
    long_name: 'Employee, Spouse, Children'
  },
  {
    id: 3,
    short_name: 'ESCP',
    long_name: 'Employee, Spouse, Children, Parents/Parents in Law'
  },
]

export const gym_membership_options = [
  {
    label: "Cult Pass Elite (12 mos)",
    value: 'elite'
  },
  {
    label: "Cult Home Workout (12 mos)",
    value: 'home'
  },
  {
    label: "No",
    value: false
  }
]

export const emotional_wellness_options = [
  {
    label: "5 sessions (1on1)",
    value: '5sessions'
  },
  {
    label: "Unlimited Sessions (1on1)",
    value: 'unlimited'
  },
  {
    label: "No",
    value: false
  }
]